import { GzStarRatingWebComponent } from './component/GzStarRatingWebComponent';

export { GzStarRatingWebComponent };
